import { useQuery } from "react-query"
import { normalFetch } from "../../fetch-api/get"

export const useGetAnalyzePairs = ({ params = {} }) => {

    return useQuery(
        ['get-analyze-pairs'], () => normalFetch(`pair?market-type=${params?.market_type || ''}`),
        {
            enabled: params?.enabled || false,
            select: res => res?.data?.data?.data
        }
    )
}

export const useGetAnalyzeAssistants = () => {

    return useQuery(
        ['get-analyze-assistants'], () => normalFetch('assistant'),
        {
            select: res => res?.data?.data?.data
        }
    )
}
